import { Component, OnDestroy } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { CellType, GridPanel } from '@grapecity/wijmo.grid'
import { NgbNav, NgbNavContent, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap'

import { BaseComponent, FuelEntry, Grid } from '../../shared'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { GridColumnGroupComponent } from '../../shared/reusable-components/grid-column-group/grid-column-group.component'
import { GridExportComponent } from '../../shared/reusable-components/grid-export/grid-export.component'
import { GridSelectionCalculationComponent } from '../../shared/reusable-components/grid-selection-calculation/grid-selection-calculation.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'

@Component({
    templateUrl: './equipment-analytics.component.html',
    standalone: true,
    imports: [
        NgbNav,
        NgbNavItem,
        NgbNavItemRole,
        NgbNavLink,
        NgbNavLinkBase,
        NgbNavContent,
        FormsModule,
        ActionToolbarCount,
        GridExportComponent,
        GridColumnGroupComponent,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
        GridSelectionCalculationComponent,
        NgbNavOutlet,
    ],
})
export class EquipmentAnalyticsComponent extends BaseComponent implements OnDestroy {
    faSearch = faSearch
    active = 1
    idleRevGrid: Grid<any>
    idleGpsGrid: Grid<any>
    pastDays = 30
    hourThreshold = 1

    constructor() {
        super()
        this.idleRevGrid = new Grid<FuelEntry>(this.services).wrapColumnHeaders()
        this.idleGpsGrid = new Grid<FuelEntry>(this.services).wrapColumnHeaders()

        this.refresh()
    }
    refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(
                    true,
                    true,
                    this.services.data.post('/api/EquipmentAnalytics/GetIdleEquipment', {
                        pastDays: this.pastDays,
                        hourThreshold: this.hourThreshold,
                    }),
                )
                .subscribe(successResult => {
                    this.initialLoadingComplete()
                    this.idleRevGrid.items = successResult[0].unusedRevenue
                    this.idleGpsGrid.items = successResult[0].unusedGps
                }),
        )
    }
    itemFormatter = (panel: GridPanel, r, c, cell: HTMLDivElement) => {
        if (panel.cellType === CellType.Cell) {
            cell.classList.remove('yellow-cell')
        }
    }
    tabChanged() {
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'))
        }, 50)
    }
}
